import React, { Component } from 'react';
import axios from 'axios';
import { injectIntl, defineMessages } from 'react-intl';
import { ModalTemplate, Button as Btn } from 'components';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as templateActions from 'modules/template';

import CodeMirrorSidebar from '../codemirror/codemirrorSidebar/CodemirrorSidebar';
import CodemirrorEditor from '../codemirror/codemirrorEditor/CodemirrorEditor';
import PhishingTemplateHeader from '../phishingTemplateHeader/PhishingTemplateHeader';
import './PhishingTemplateModal.css';

class PhishingTemplateModal extends Component {
  constructor(props) {
    super();

    const { mode, phishingInfo } = props.config;
    const language = localStorage.getItem('language');
    const finishText = '${STAGE_FINISH}$';

    var mailbodyEx = '';
    if (language === 'en') {
      mailbodyEx = `<div style="color: #333333; font-family: 'Arial', sans-serif; padding: 0; text-align: left">
  Write the body of the mail. <br />
  <br />
  If you write as follows, result content is displayed when you click the URL.<br />
  (You can freely change the URL used for https://~.)<br />
  <a href=${finishText} target="_blank">https://mudfix.co.kr/phishing/sample</a><br />
  <br />
</div>`
    } else if (language === 'ja') {
      mailbodyEx = `<div style="color: #333333; font-family: 'MEIRYO', sans-serif; padding: 0; text-align: left">
  ここにメール本文を書きます。<br />
  <br />
  以下のように記述すると感染後画面が表示され感染となります。<br />
  (https://～のURLは自由に変更することが可能です。)<br />
  <a href=${finishText} target="_blank">https://mudfix.jp/phishing/sample</a><br />
  <br />
</div >`
    } else {
      mailbodyEx = `<div style="color: #333333; font-family: 'Malgun Gothic', sans-serif; padding: 0; text-align: left">
  메일 본문을 작성합니다.<br />
  <br />
  다음과 같이 작성하면 URL 클릭 시 감염 후 화면이 표시됩니다.<br />
  (https://~ 에 사용할 URL은 자유롭게 변경할 수 있습니다.)<br />
  <a href=${finishText} target="_blank">https://mudfix.co.kr/phishing/sample</a><br />
  <br />
</div>`
    }

    this.state = {
      phishingName: '',
      phishingLevel: 1,
      currentStep: 0,
      templates: [
        {
          html: mailbodyEx.toString()
        }
      ],
      phishingResult: {
        html: '',
        css: '',
        js: ''
      },
      reviewStatus: 'off',
      reviewItem: {},
      phishingNo: null,
      nameRef: null,
      phishingPublic: mode === 'edit' ? phishingInfo.isPublic : 0,
      previewURL: '',
      phishingScreenEnable: mode === 'edit' ? phishingInfo.phishingScreenEnable : 1,
      images: phishingInfo && phishingInfo.imageList ? phishingInfo.imageList : [],
      uploadedList: []
    };
  }

  componentDidMount() {
    const { config } = this.props;
    if (config.mode === 'add') {
      // 등록일 경우 페이지 새로고침시 새로 생성된 phisningNo 제거
      window.addEventListener('beforeunload', this.removePhishingWhenRefresh);
      axios.post('/api/v1/Template/Phishing').then(respData => {
        this.setState({ phishingNo: respData.data.list[0].phishingNo });
      });
    } else if (config.mode === 'edit') {
      const {
        phishingNo,
        phishingName,
        phishingLevel,
        phishingMailbody,
        phishingHtml1,
        phishingCss1,
        phishingJs1,
        phishingHtml2,
        phishingCss2,
        phishingJs2,
        phishingHtml3,
        phishingCss3,
        phishingJs3,
      } = config.phishingInfo;
      const tempCopy = [...this.state.templates];
      tempCopy[0].html = phishingMailbody;
      tempCopy[1] = { html: phishingHtml1, css: phishingCss1, js: phishingJs1 };
      tempCopy[2] = { html: phishingHtml2, css: phishingCss2, js: phishingJs2 };

      this.setState({
        phishingNo,
        phishingName,
        phishingLevel,
        templates: tempCopy,
        phishingResult: {
          html: phishingHtml3,
          css: phishingCss3,
          js: phishingJs3
        }
      });
    }
  }

  componentWillUnmount() {
    window.removeEventListener('beforeunload', this.removePhishingWhenRefresh);
  }

  setCurrentStepHandler = step => {
    if (this.state.currentStep === step) return;
    this.setState({ currentStep: step, reviewStatus: 'off' });
  };

  getMirrorHandler = (type, curStep, value) => {
    //curStep -> 0: 메일 본문, 1: 단계1, 2: 단계2, 3: 결과 화면
    if (curStep === 3) {
      const item = { ...this.state.phishingResult, [type]: value };
      this.setState({ phishingResult: item });
    } else {
      const templates = [...this.state.templates];
      const item = { ...templates[curStep], [type]: value };
      templates[curStep] = item;
      this.setState({ templates });
    }
  };

  setPhishingNameHandler = e => {
    this.setState({ phishingName: e.target.value });
  };

  setNameRef = nameRef => {
    this.nameRef = nameRef;
  };

  // 공개 설정 여부 설정 이벤트
  setPublicHandler = value => {
    this.setState({ phishingPublic: value });
  };

  // 결과 화면 사용 여부 설정 이벤트
  setScreenHandler = value => {
    const initValue = {
      currentStep: 0,
      previewURL: null,
      reviewStatus: 'off',
      reviewItem: {}
    };

    this.setState({ phishingScreenEnable: value, ...initValue });
  };

  // 새로고침시 저장하지 않은 피싱 템플릿  Delete
  removePhishingWhenRefresh = () => {
    if (!!this.state.phishingNo) {
      axios.delete('/api/v1/Template/PhishingInsertCancle', {
        params: { phishingNo: this.state.phishingNo }
      });
    }
  };

  // 단계 증가 이벤트
  increaseStepHandler = () => {
    if (this.state.phishingLevel === 3) return;
    this.setState({
      phishingLevel: this.state.phishingLevel + 1,
      templates: [
        ...this.state.templates,
        {
          html: '',
          css: '',
          js: ''
        }
      ]
    });
  };

  // 단계 감소 이벤트
  decreaseStepHandler = () => {
    const { phishingLevel, currentStep, templates } = this.state;
    if (phishingLevel === 1) return;
    this.setState({
      phishingLevel: phishingLevel - 1,
      templates: templates.slice(0, -1)
    });
    if (currentStep + 1 >= phishingLevel) this.setState({ currentStep: currentStep === 3 ? 3 : currentStep - 1 });
  };

  // 실행 버튼 이벤트
  runCodeHandler = () => {
    const { templates, currentStep, phishingResult } = this.state;
    const url = this.codeResultUrl({
      html: currentStep === 3 ? phishingResult.html : templates[currentStep].html,
      css: currentStep === 3 ? phishingResult.css : templates[currentStep].css,
      js: currentStep === 3 ? phishingResult.js : templates[currentStep].js
    });

    this.setState({
      reviewItem: templates[currentStep],
      reviewStatus: 'on',
      previewURL: url
    });
  };

  keyRunCodeHandler = e => {
    if (e.ctrlKey && e.keyCode === 13) this.runCodeHandler();
  };

  codeResultUrl = ({ html, css, js }) => {
    const parseCode = (code) => {
      if (code) {
        const date = new Date();
        const month = date.getMonth();
        const doubleDigitMonth = month < 10 ? '0' + month : month;

        return code
          .replace(/\$\{SERVER_ROOT\}\$/g, window.location.origin)
          .replace(/\$\{DATE_YM\}\$/g, date.getFullYear() + doubleDigitMonth);
      } else {
        return '';
      }
    };

    const parsedHTML = parseCode(html);
    const parsedCSS = parseCode(css);
    const parsedJS = parseCode(js);
    const source = `
      <html>
        <head>
          <style>${parsedCSS}</style>
        </head>
        <body>
          ${parsedHTML}
          <script src="${window.location.origin}/certification/jquery/jquery-1.10.2.min.js"></script>
          <script>${parsedJS}</script>
        </body>
      </html>
    `;

    var iframeDoc = document.getElementById(`custom-phishing-template ${this.state.reviewStatus}`).contentWindow.document;
    iframeDoc.open();
    iframeDoc.write(source);
    iframeDoc.close();
  };

  // 저장 버튼 이벤트
  submitPhishingTemplate = async ({ phishingNo, phishingLevel, templates, phishingName, phishingResult, phishingScreenEnable }) => {
    if (!phishingName) {
      this.nameRef.focus();
      return;
    }

    const { TemplateActions, toggleModal, isAuth, config } = this.props;
    const { phishingPublic, uploadedList } = this.state;

    try {
      // 등록
      if (config.mode === 'add') {
        const origin = uploadedList;
        const current = this.state.images;
        this.deleteImages(origin, current, current, 1);
      }
      // 수정
      else {
        const origin = config.phishingInfo.imageList;
        const current = this.state.images;
        this.deleteImages(origin, current, current, 1);
      }

      const params = {
        phishingNo,
        phishingName,
        phishingLevel,
        phishingMailbody: templates[0].html,
        phishingHtml1: templates[1] ? templates[1].html : null,
        phishingCss1: templates[1] ? templates[1].css : null,
        phishingJs1: templates[1] ? templates[1].js : null,
        phishingHtml2: templates[2] ? templates[2].html : null,
        phishingCss2: templates[2] ? templates[2].css : null,
        phishingJs2: templates[2] ? templates[2].js : null,
        phishingHtml3: phishingResult.html ? phishingResult.html : null,
        phishingCss3: phishingResult.css ? phishingResult.css : null,
        phishingJs3: phishingResult.js ? phishingResult.js : null,
        phishingScreenEnable
      };

      // 관리자일 경우에만 isPublic 파라미터 보냄
      if (isAuth === 2) {
        params['isPublic'] = phishingPublic;
      }

      await TemplateActions.savePhishingTemplate(params);
    } catch (e) {
      console.log(e);
    }
    toggleModal();
  };

  cancelPhishingTemplate = async () => {
    const { config, toggleModal } = this.props;

    // 등록
    if (config.mode === 'add') {
      const origin = [];
      const current = this.state.uploadedList;
      this.deleteImages(origin, current, origin, 2);

      // 생성된 phishingNo 삭제
      axios.delete('/api/v1/Template/PhishingInsertCancle', {
        params: { phishingNo: this.state.phishingNo }
      });
    }
    // 수정
    else {
      const origin = config.phishingInfo.imageList;
      const current = this.state.images;
      this.deleteImages(origin, current, origin, 2);
    }

    toggleModal();
  };

  // 이미지 업로드, 삭제 버튼 클릭 시 이미지 리스트 변경
  getImages = (type, value) => {
    if (type === 'upload') {
      this.setState({
        uploadedList: value,
        images: value
      });
    } else {
      this.setState({
        images: value
      });
    }
  };

  // 업로드된 이미지 삭제
  deleteImages = async (origin, current, newImages, type) => {
    // origin: 기존 이미지 리스트, current: 현재 이미지 리스트, newImages: 이미지 목록에 보여줄 리스트, type: 비교 기준 설정(1: origin, 2: current)  
    const originNoArray = origin && origin.length > 0 ? origin.map(item => item.imageNo) : [];
    const currentNoArray = current.length > 0 ? current.map(item => item.imageNo) : [];
    const mainArray = type === 1 ? originNoArray : currentNoArray;
    const subArray = type === 1 ? currentNoArray : originNoArray;

    if (mainArray.length > 0) {
      const differentNoArray = mainArray.filter(element => subArray.indexOf(element) < 0);
      if (differentNoArray.length > 0) {
        const fileParams = {
          phishingNo: this.state.phishingNo,
          imageNoArray: JSON.stringify(differentNoArray)
        };
        await axios.delete('/api/v1/Template/PhishingUploadImage', { params: fileParams });
      }

      // 이미지 리스트 업데이트
      this.setState({
        images: newImages
      });
    }
  }

  render() {
    // 국제화 처리
    const { formatMessage } = this.props.intl;
    const { phishingNo, phishingLevel, currentStep, templates, reviewStatus, phishingName, phishingPublic, previewURL, phishingScreenEnable, phishingResult } = this.state;
    const { isAuth, config } = this.props;

    return (
      <ModalTemplate
        closeOnEscape={false}
        closeOnDimmerClick={false}
        closeOnDocumentClick={false}
        className="modal-phishing-template-add"
        onToggleModal={this.props.toggleModal}
        visible
        header={
          <PhishingTemplateHeader
            runCodeHandler={this.runCodeHandler}
            submitPhishingTemplate={() => this.submitPhishingTemplate(this.state)}
          />
        }
        buttons={
          <div className="action-btn">
            <div onClick={this.cancelPhishingTemplate}>
              {defineMessages(
                formatMessage({
                  id: 'ExamTemplateEditModal_4',
                  defaultMessage: '취 소'
                })
              )}
            </div>
          </div>
        }>
        <div className="phishing-template-add-wrapper" onKeyDown={this.keyRunCodeHandler}>
          <CodeMirrorSidebar
            phishingName={phishingName}
            phishingNo={phishingNo}
            phishingLevel={phishingLevel}
            currentStep={currentStep}
            setPhishingNameHandler={this.setPhishingNameHandler}
            increaseStepHandler={this.increaseStepHandler}
            decreaseStepHandler={this.decreaseStepHandler}
            setCurrentStepHandler={this.setCurrentStepHandler}
            setNameRef={this.setNameRef}
            isAuth={isAuth}
            phishingPublic={phishingPublic}
            setPublicHandler={this.setPublicHandler}
            phishingScreenEnable={phishingScreenEnable}
            setScreenHandler={this.setScreenHandler}
            images={this.state.images}
            getImages={this.getImages}
            scrolling
          />
          {currentStep === 3 && phishingScreenEnable === 1 ?
            <CodemirrorEditor
              key={3}
              getMirrorHandler={this.getMirrorHandler}
              curStep={3}
              isAuth={isAuth}
              data={phishingResult}>
              <iframe
                id={`custom-phishing-template ${reviewStatus}`}
                className={`custom-phishing-template ${reviewStatus}`}
                // src={reviewStatus === 'on' ? previewURL : null}
              />
            </CodemirrorEditor>
            :
            templates.map((item, i) => {
              const curStep = currentStep;
              return (
                curStep === i && (
                  <CodemirrorEditor
                    key={i}
                    getMirrorHandler={this.getMirrorHandler}
                    curStep={curStep}
                    isAuth={isAuth}
                    data={templates[curStep]}>
                    <iframe
                      id={`custom-phishing-template ${reviewStatus}`}
                      className={`custom-phishing-template ${reviewStatus}`}
                      // src={reviewStatus === 'on' ? previewURL : null}
                    />
                  </CodemirrorEditor>
                )
              );
            })
          }
        </div>
      </ModalTemplate>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  TemplateActions: bindActionCreators(templateActions, dispatch)
});

export default connect(null, mapDispatchToProps)(injectIntl(PhishingTemplateModal));



// WEBPACK FOOTER //
// ./src/script/components/phishingTemplate/phishingTemplateModal/phishingTemplateModal/PhishingTemplateModal.js